import React from 'react'
import {MotionProps, motion} from 'framer-motion'
import {ThemeProvider, BaseStyles, Box, BoxProps, Text, Heading, AtlasButton} from '../../..'

export type ResetPromptProps = Omit<BoxProps, keyof MotionProps> & {
  onReset: () => void
}
export const MotionBox = motion<BoxProps>(Box)

export const ResetPrompt = ({onReset, ...rest}: ResetPromptProps): JSX.Element => {
  return (
    <MotionBox
      px={4}
      py={4}
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      animate={{opacity: 1}}
      initial={{opacity: 0}}
    >
      <Heading sx={{fontSize: 3}}>All steps completed!</Heading>
      <AtlasButton sx={{mt: 6}} size={`small`} onClick={onReset}>
        Reset
      </AtlasButton>
    </MotionBox>
  )
}
export type StepButtonsProps = {
  nextStep?: () => void
  prevStep?: () => void
  prevDisabled?: boolean
  nextDisabled?: boolean
  isLast?: boolean
}
export const StepButtons = ({
  nextStep,
  prevStep,
  prevDisabled,
  nextDisabled,
  isLast
}: StepButtonsProps): JSX.Element => {
  return (
    <Box display="flex" width="100%" justifyContent="flex-end" sx={{gap: 2}}>
      <AtlasButton mr={4} appearance={`subtle`} onClick={prevStep} disabled={prevDisabled}>
        Prev
      </AtlasButton>

      <AtlasButton onClick={nextStep}>{isLast ? 'Finish' : 'Next'}</AtlasButton>
    </Box>
  )
}
export type ContentProps = BoxProps & {
  index: number
}
export const Content = ({index, ...rest}: ContentProps) => {
  return (
    <Box
      p={6}
      bg={`elevation.surface.sunken`}
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        borderRadius: 2
      }}
      {...rest}
    >
      <Text>Step {index + 1}</Text>
    </Box>
  )
}
